import { JSONSchema7 } from 'json-schema'

import { ActiveGeometryGroup } from '../../../../../../imup/slices/geometry'
import { DocumentMapping } from '../../../../../../models/documentMapping'
import { Region } from '../../../../../../models/region'

export const calculateDefaultStairLocation = (
    activeDocumentMapping: DocumentMapping | undefined,
    schema: JSONSchema7,
    activeDrawableGroup: ActiveGeometryGroup | null,
    regions: Region[]
) => {
    const MAIN_FLOOR_LEVEL = '1ST'
    const MAIN_FLOOR_PAGE_NAME_STARTER = 'main'

    if (
        activeDocumentMapping &&
        activeDocumentMapping.page_name &&
        schema.definitions &&
        schema.definitions.stairs_location &&
        schema.properties?.version
    ) {
        const extractLevelFromName = (pageName: string) =>
            !pageName.toLocaleLowerCase().startsWith(MAIN_FLOOR_PAGE_NAME_STARTER)
                ? pageName.split(' ')[0]
                : MAIN_FLOOR_LEVEL

        const potentialRegionId = activeDrawableGroup?.openings
            .flatMap((opening) => opening.opening_locations.map((location) => location.region_id))
            .find((regionId) => regionId !== null)

        const potentialRegion =
            potentialRegionId !== undefined ? regions.find((region) => region.id === potentialRegionId) : undefined

        const level = extractLevelFromName(potentialRegion?.name ?? activeDocumentMapping.page_name)

        const stairLocationDef = schema.definitions.stairs_location as {
            type: string
            enum: string[]
            enumNames: string[]
        }

        const associatedLocationSelection = stairLocationDef.enum.find(
            (location) => location.includes(level) && location.startsWith(level)
        )

        return associatedLocationSelection
    }

    return undefined
}
